import { Box, Typography, useMediaQuery } from '@mui/material';
import { PORTRAIT_API, POST_BY_IDS_API } from '../../api/endpoint';
import { Post, PostDetail } from '../../types';
import React, { useEffect, useRef, useState } from 'react';

import axiosInstance from '../../api/axiosConfig';
import createAxiosInstance from '../../api/axiosConfig';
import { useNavigate } from 'react-router-dom';

const TopPortraits = () => {
  const navigate = useNavigate();
  const [landscapes, setPortraits] = useState<Post[]>([]);
  const [postDetails, setPostDetails] = useState<PostDetail[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [currentPage, setCurrentPage] = useState<string | null>(null);
  const isFetching = useRef(false);
  const isMobile = useMediaQuery('(max-width:600px)');

  const scrollRef = useRef<HTMLDivElement | null>(null);
  const scrollSpeed = 70;

  useEffect(() => {
    fetchPortraits();
  }, []);

  useEffect(() => {
    if (postDetails.length < 5 && currentPage) {
      fetchPortraits(currentPage, 5 - postDetails.length);
    }
  }, [postDetails, currentPage]);

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;

    const scroll = () => {
      if (scrollContainer.scrollLeft >= scrollContainer.scrollWidth / 2) {
        scrollContainer.scrollLeft = 0;
      } else {
        scrollContainer.scrollLeft += 1;
      }
    };

    const interval = setInterval(scroll, scrollSpeed);

    scrollContainer.addEventListener('mouseenter', () => clearInterval(interval));
    scrollContainer.addEventListener('mouseleave', () => setInterval(scroll, scrollSpeed));

    return () => clearInterval(interval);
  }, [postDetails]);

  const fetchPortraits = async (pageToken: string | null = null, count = 20) => {
    if (!isFetching.current) {
      isFetching.current = true;
      try {
        const axiosInstance = createAxiosInstance(true);
        const response = await axiosInstance.get(PORTRAIT_API, {
          params: { page: pageToken || '', count }
        });

        if (!response?.data?.data?.length) return;

        setPortraits((prev) => [...prev, ...response.data.data]);
        setCurrentPage(response.data.page);

        const postIds = response.data.data.map((portrait: Post) => portrait.post_id);
        if (postIds.length > 0) {
          const detailsAxios = createAxiosInstance(false);
          const postDetailsResponse = await detailsAxios.get(`${POST_BY_IDS_API}${postIds.join(',')}`);
          const shuffledData = postDetailsResponse.data.data.sort(() => Math.random() - 0.5);
          setPostDetails((prevPostDetails) => [...prevPostDetails, ...shuffledData]);
        }
      } catch (error) {
        setError('Failed to fetch portraits.');
      } finally {
        setLoading(false);
        isFetching.current = false;
      }
    }
  };

  if (error) {
    return (
      <Typography variant="h6" color="error">
        Error: {error}
      </Typography>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        margin: isMobile ? '3rem 0 0 0' : '5rem  0'
      }}>
      <Typography
        style={{
          fontSize: isMobile ? '28px' : '52px',
          fontWeight: 800,
          color: 'white',
          paddingBottom: '10px',
          fontFamily: 'Baloo2'
        }}>
        Top Portraits
      </Typography>

      <Box
        ref={scrollRef}
        sx={{
          display: 'flex',
          gap: '30px',
          overflowX: 'auto',
          whiteSpace: 'nowrap',
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          width: '100%',
          padding: '16px'
        }}>
        {postDetails.map((postDetail, index) => (
          <Box
            key={index}
            sx={{
              height: isMobile ? '168px' : '420px',
              width: isMobile ? '128px' : '320px',
              border: isMobile ? '4px solid white' : '10px solid white',
              borderRadius: isMobile ? '16px' : '40px',
              flexShrink: 0
            }}>
            <button
              onClick={() => navigate(`/work/${postDetail.post_id}`)}
              style={{
                all: 'unset',
                display: 'block',
                width: '100%',
                height: '100%',
                cursor: 'pointer',
                borderRadius: '30px'
              }}>
              <img
                src={`${process.env.REACT_APP_DEFAULT_AVATAR}/${postDetail.user_id}/WORKS/IMAGES/medium/${postDetail.files[0].name}`}
                alt={postDetail.text}
                style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: isMobile ? '12px' : '30px' }}
                onError={(e) => ((e.target as HTMLImageElement).src = process.env.REACT_APP_NO_IMAGE || '')}
              />
            </button>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default TopPortraits;
